export default function updateValidationData (state, payload) {
    return {
      ...state,
      validationData: {
        ...state.validationData,
        ...payload
      }
    }
  }
